import { createSearchHook } from "./createSearchHook";

const [useSearchJumpTo, searchJumpTo] = createSearchHook("searchJumpTo", "jumpTo");

export default useSearchJumpTo;
export { searchJumpTo };
